<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box" style="display: flex; overflow: hidden">
      <div
        style="
          flex: 1;
          margin-right: 10px;
          display: flex;
          flex-direction: column;
          overflow-y: auto;
        "
      >
        <ul
          style="
            padding-bottom: 10px;
            border-bottom: 1px solid #e2e2e2;
            margin-bottom: 10px;
          "
        >
          工资表信息
        </ul>
        <el-form :model="state.model" ref="formDom" style="max-width: 80%">
          <el-form-item
            label="名称"
            prop="name"
            :rules="[
              { required: true, message: '请填写名称', trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.name"></el-input>
          </el-form-item>
          <el-form-item
            label="薪资所属期"
            prop="month"
            :rules="[
              { required: true, message: '请选择薪资所属期', trigger: 'blur' },
            ]"
          >
            <el-date-picker
              v-model="state.model.month"
              type="month"
              format="YYYY年M月"
              value-format="YYYY-MM"
              :disabled="props.id"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item
            label="税款所属期"
            prop="tax_month"
            :rules="[
              { required: true, message: '请选择税款所属期', trigger: 'blur' },
            ]"
          >
            <el-date-picker
              v-model="state.model.tax_month"
              type="month"
              format="YYYY年M月"
              value-format="YYYY-MM"
              :disabled="props.id"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item
            label="报税类型"
            prop="d_tax_type_id"
            :rules="[
              { required: true, message: '请选择报税类型', trigger: 'blur' },
            ]"
          >
            <el-select v-model="state.model.d_tax_type_id" :disabled="props.id">
              <el-option
                v-for="item in state.taxTypeData"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
              <template #footer>
                <el-button size="small" @click="onLoadTaxType()">
                  刷新
                </el-button>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item
            label="发放日期"
            prop="pay_date"
            :rules="[
              { required: true, message: '请选择发放日期', trigger: 'blur' },
            ]"
          >
            <el-date-picker
              v-model="state.model.pay_date"
              type="date"
              value-format="YYYY-MM-DD"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item
            label="客服专员"
            prop="belonger_id"
            :rules="[
              { required: true, message: '请选择客服专员', trigger: 'blur' },
            ]"
          >
            <el-tree-select
              v-model="state.model.belonger_id"
              :props="{
                value: 'id',
                label: 'name',
                class: 'belonger-tree-class',
              }"
              placeholder="负责人"
              :data="state.admin_data"
              style="width: 100%"
              default-expand-all
              filterable
              clearable
              @current-change="onBelongerChange"
            >
              <template #default="{ data }">
                <el-icon :size="16" v-if="data.type == 0"
                  ><UserFilled
                /></el-icon>
                <el-icon :size="16" v-else><User /></el-icon>
                <span style="margin-left: 3px">{{ data.name }}</span>
              </template>
            </el-tree-select>
          </el-form-item>
          <el-form-item
            label="个税承担方式"
            prop="tax_mode"
            :rules="[
              {
                required: true,
                message: '请选择个税承担方式',
                trigger: 'blur',
              },
            ]"
          >
            <el-radio-group v-model="state.model.tax_mode">
              <el-radio-button :label="0">个人</el-radio-button>
              <el-radio-button :label="1">公司</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div
        style="
          flex: 1.3;
          padding-left: 10px;
          display: flex;
          flex-direction: column;
          overflow: hidden;
        "
      >
        <ul
          style="
            padding-bottom: 10px;
            border-bottom: 1px solid #e2e2e2;
            margin-bottom: 10px;
          "
        >
          您当前已选择：
          <strong style="color: #1e90ff; font-weight: 600">{{
            state.tableData?.length || 0
          }}</strong>
          位员工
        </ul>
        <el-table
          ref="tableDom"
          :data="state.tableData"
          v-loading="!Array.isArray(state.tableData)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
        >
          <el-table-column
            fixed
            label="序号"
            width="70"
            type="index"
            align="center"
          />
          <el-table-column
            label="姓名"
            prop="name"
            :min-width="80"
            :formatter="$tab_TextFormat"
            fixed
          />
          <el-table-column prop="idcard" label="证件号" width="180">
            <template #default="{ row }">
              <text
                style="color: #1e90ff"
                class="text-hover-decoration"
                title="证件号"
                @click.stop="$onCopy(row.idcard)"
              >
                {{ row.idcard }}
              </text>
            </template>
          </el-table-column>
          <el-table-column label="证件类型" prop="idtype" :min-width="120" />
          <el-table-column label="扣缴义务人" prop="status" :min-width="200">
            <template #default="{ row }">
              <div
                v-if="row.withholding_agent_id"
                :data-type="row.withholding_agent_type == 1 ? '供' : '扣'"
                :style="{
                  '--dynamic-color':
                    row.withholding_agent_type == 1 ? '#1e90ff' : '#ffa500',
                }"
                class="withholding-badge"
              >
                <text
                  style="color: #1e90ff"
                  class="text-hover-decoration"
                  title="扣缴义务人"
                  @click.stop="$onCopy(row.withholding_agent_name)"
                >
                  {{ row.withholding_agent_name }}
                </text>
              </div>
              <text v-else>-</text>
            </template>
          </el-table-column>
          <el-table-column
            label="统一社会信用代码"
            prop="unified_social_credit_identifier"
            :min-width="160"
          />
          <el-table-column
            label="所属客户"
            prop="customer_name"
            :min-width="200"
          />
          <el-table-column
            label="负责人"
            prop="belonger_name"
            :min-width="120"
          />
          <el-table-column label="属性" prop="property_name" :min-width="120" />
          <el-table-column
            label="入职日期"
            prop="entry_time"
            :min-width="120"
          />
          <el-table-column
            label="离职日期"
            prop="resignation_time"
            :min-width="120"
          />
          <el-table-column
            label="人员状态"
            prop="verify_status_name"
            :min-width="120"
          />
          <el-table-column
            label="报送状态"
            prop="declare_status_name"
            :min-width="120"
          />
          <el-table-column
            label="报送时间"
            prop="declare_time"
            :min-width="180"
          />
          <el-table-column
            label="操作"
            width="90"
            align="center"
            fixed="right"
            v-if="$judge_auth(['566', '567'])"
          >
            <template #default="{ $index }">
              <el-button
                type="danger"
                link
                icon="Delete"
                @click="onDelete($index)"
                >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </ul>
    <ul class="submit-box">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { uncalctaxemployee_zerodeclares } from "@/http/uncalctaxemployee";
import { admin_cascader } from "@/utils/qFormat";
import { data_customer_select } from "@/http/data";
import { taxtype_select } from "@/http/dictionary";
import { post_response } from "@/utils/qFormat";
import { ElMessageBox } from "element-plus";

export default {
  props: {
    items: Array,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      state.tableData = props.items;
      onLoadCustomer();
      onLoadAdmin();
      onLoadTaxType();
    });

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    //获取业务员
    const onLoadAdmin = () => {
      admin_cascader().then((res) => {
        state.admin_data = res;
      });
    };

    //业务员改变事件需要获取其部门id
    const onBelongerChange = (item) => {
      state.model.belonger_department_id = item.pid;
    };

    const onLoadTaxType = () => {
      taxtype_select().then((res) => {
        if (res.status == 200) state.taxTypeData = res.data.data;
      });
    };

    const onDelete = (index) => {
      ElMessageBox.confirm(
        `您确定<strong style='color:#f00'>删除</strong>该员工吗？(该员工吗？操作仅针对本次零申报，不影响该员工的其他数据！)`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        state.tableData.splice(index, 1);
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          state.model.id = props.items.map((m) => m.id).join(",");
          uncalctaxemployee_zerodeclares(JSON.stringify(state.model)).then(
            (res) => {
              post_response(res, emit);
            }
          );
        }
      });
    };
    return {
      state,
      props,
      formDom,
      onSubmit,
      onLoadCustomer,
      onLoadAdmin,
      onLoadTaxType,
      onBelongerChange,
      onDelete,
    };
  },
};
</script>
<style scoped lang="less"></style>
